"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _functions = require("../../../../@functions");
var _apis = require("../../../../@apis");
var _i18n = require("../../../../@i18n");
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef CNPJData
 * @type {import("./index.jsx").CNPJData}
 */

/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/**
 * @param {StepProps} props
 */
function ConfirmCompany(props) {
  var user = props.user,
    goNext = props.goNext,
    goBack = props.goBack;
  /** @type {[CNPJData | undefined, React.Dispatch<React.SetStateAction<CNPJData | undefined>>]} */
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    companyData = _useState2[0],
    setCompanyData = _useState2[1];
  var handleConfirmCompany = function handleConfirmCompany() {
    goNext(_objectSpread(_objectSpread({}, user), {}, {
      company: companyData
    }));
  };
  (0, _react.useEffect)(function () {
    ;
    (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var cnpj, data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cnpj = user.identificationNumber;
            _context.prev = 1;
            _context.next = 4;
            return _apis.receitaApi.consult(cnpj);
          case 4:
            data = _context.sent;
            setCompanyData(data);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setCompanyData(undefined);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }))();
  }, [user.identificationNumber]);
  var loaded = !!companyData;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: goBack
  }, "\xAB Voltar"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, loaded ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-highlight"
  }, "Esta \xE9 a sua empresa?")), /*#__PURE__*/_react["default"].createElement("p", null, "Raz\xE3o social: ", /*#__PURE__*/_react["default"].createElement("strong", null, companyData.nome || 'Não informado'), /*#__PURE__*/_react["default"].createElement("br", null), "Nome fantasia: ", /*#__PURE__*/_react["default"].createElement("strong", null, companyData.fantasia || 'Não informado'), /*#__PURE__*/_react["default"].createElement("br", null), "CNPJ: ", /*#__PURE__*/_react["default"].createElement("strong", null, user.identificationNumber), /*#__PURE__*/_react["default"].createElement("br", null), "Email: ", /*#__PURE__*/_react["default"].createElement("strong", null, companyData.email || 'Não informado'), /*#__PURE__*/_react["default"].createElement("br", null), "Telefone: ", /*#__PURE__*/_react["default"].createElement("strong", null, companyData.telefone || 'Não informado'), /*#__PURE__*/_react["default"].createElement("br", null), "Abertura: ", /*#__PURE__*/_react["default"].createElement("strong", null, _i18n.format.date((0, _functions.toDate)(companyData.abertura)))), /*#__PURE__*/_react["default"].createElement("p", null, "\xDAltima atualiza\xE7\xE3o em", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-highlight"
  }, _i18n.format.datetime((0, _functions.toDate)(companyData.ultima_atualizacao))))) : /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centerdText"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-highlight"
  }, "Carregando..."))), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleConfirmCompany,
    disabled: !loaded
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Sim, \xE9 minha empresa"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faCity"
  })));
}
ConfirmCompany.propTypes = {
  user: _propTypes["default"].shape({
    identificationNumber: _propTypes["default"].string.isRequired
    // add other required user prop types here
  }).isRequired,
  goNext: _propTypes["default"].func.isRequired,
  goBack: _propTypes["default"].func.isRequired
};
var _default = ConfirmCompany;
exports["default"] = _default;